import styled from 'styled-components';

export const StyledRadioLabel = styled.label`
  display: block; 
  margin: 1% 7%;
`;
